/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_ProductCatalog_Export_ModifiedSitemapProducts } from '../models/Gsoa_ProductCatalog_Export_ModifiedSitemapProducts';
import type { Gsoa_ProductCatalog_Export_SitemapProducts } from '../models/Gsoa_ProductCatalog_Export_SitemapProducts';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaProductCatalogExportService {
    /**
     * @returns Gsoa_ProductCatalog_Export_ModifiedSitemapProducts OK
     * @throws ApiError
     */
    public static exportModifiedSitemapProducts({
        modifiedFrom,
        apiVersion = 1,
    }: {
        modifiedFrom: string,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_ProductCatalog_Export_ModifiedSitemapProducts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/exports/web/modifiedSitemapProducts',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'modifiedFrom': modifiedFrom,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * @returns Gsoa_ProductCatalog_Export_SitemapProducts OK
     * @throws ApiError
     */
    public static exportSitemapProducts({
        apiVersion = 1,
        listedProductOnly = true,
        filter,
        page,
        pageSize = 50,
        inCategoryOnly = false,
        activeOnly = true,
    }: {
        apiVersion?: number,
        listedProductOnly?: boolean,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary>Supported operators:</summary>
         * <p><i>eq</i> - checks if attribute is equal. Case sensitive when literal attribute.</p>
         * </details>
         * <details>
         * <summary>Supported attributes - examples:</summary>
         * <p>Vanr:eq Abc </br></p>
         * </details>
         * </p>
         */
        filter?: string,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        inCategoryOnly?: boolean,
        activeOnly?: boolean,
    }): CancelablePromise<Gsoa_ProductCatalog_Export_SitemapProducts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/exports/web/sitemapProducts',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'listedProductOnly': listedProductOnly,
                'filter': filter,
                'page': page,
                'pageSize': pageSize,
                'inCategoryOnly': inCategoryOnly,
                'activeOnly': activeOnly,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                500: `An error occurred.`,
            },
        });
    }
}
